module.exports = __webpack_public_path__ + "static/img/bg-pt.30755d40.png";